import { useState, useCallback } from 'react';
import { message } from 'antd';
import { LoadingOutlined, ExportOutlined } from '@ant-design/icons';

import request from '@/request';

export default function ExportButton({ api }) {
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(async () => {
    setLoading(true);
    try {
      const fileUrl = await request.post(api);
      // 创建隐藏的 a 标签触发下载
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      message.success('导出成功');
    } catch (error) {
      console.error('请求失败:', error);
      message.error('导出失败');
    } finally {
      setLoading(false);
    }
  }, [api]);

  return (
    <button
      disabled={loading}
      onClick={onClick}
      aria-label="导出"
      className={`h-9 flex items-center justify-center gap-2 px-4 text-sm font-medium text-white bg-emerald-500 rounded-lg hover:bg-emerald-600 shadow-sm transition-colors cursor-pointer sm:w-auto ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      {loading ? <LoadingOutlined /> : <ExportOutlined />}
      <span>导出</span>
    </button>
  );
}
